import RecentlyViewedGoods from './pages/RecentlyViewedGoods/RecentlyViewedGoods.page';
import type { ScreenItem } from 'shared/src/types';
import { GoodsDetailPage } from './pages/GoodsDetail';
import { isWeb } from 'shared/src/utils';

export const GoodsScreens: ScreenItem[] = [
  {
    name: 'RecentlyViewedGoods',
    component: RecentlyViewedGoods,
    path: '/mypage/recently-viewed-goods',
    options: {
      title: '최근 본 상품 - 에이블리 스토어',
    },
  },
  {
    name: 'GoodsDetail',
    component: GoodsDetailPage,
    path: '/goods/:goodsId',
    options: {
      title: '상품 상세 - 에이블리 스토어',
    },
    convertParams: props => {
      const extras =
        typeof props.extras === 'string'
          ? JSON.parse(props.extras)
          : (props.extras ?? {});
      if (isWeb) {
        return {
          instanceId: props.instanceId,
          extras:
            typeof props.extras === 'string'
              ? JSON.parse(props.extras)
              : props.extras,
        };
      }

      return {
        instanceId: props.instanceId,
        goodsId:
          extras.sno ??
          extras.TARGET.goods_sno ??
          extras.TARGET.b ??
          extras.TARGET.b?.goods_sno ??
          extras.TARGET.c?.goods_sno,
        extras: extras,
      };
    },
  },
];
